import { createAction, props } from '@ngrx/store';
import { EntityKey } from '../pma-entity-types';

export const EntityKeyUpdated = createAction(
  '[Entity Key Service] Entity Key Updated',
  props<{ entityKey: EntityKey }>()
);